import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import UserActions from '../containers/UserActions';
import { closeUser } from '../actions';
import UserPanel from '../components/UserPanel';

export default {
  ...tabTemplate('user', UserPanel, matchCodeUrl(['users']), UserActions),
  ...tabCloser('closeUserTab', closeUser),
  ...tabIcons('user'),
  access: ({ users }, { isCurrentUser }) => users.read || isCurrentUser,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  order: 805,
};
